var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupportHelpIcon = function SvgSupportHelpIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -654) translate(40 651.353) translate(0 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12.143,
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 2.55
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.081,
    d: "M7.66 2.134L8.757 6.6c.064.256.262.458.518.525l4.05 1.059c.193.05.308.247.258.44-.032.122-.125.218-.246.254l-4.086 1.221c-.242.073-.43.267-.492.513l-1.102 4.327c-.049.193-.245.31-.438.26-.132-.034-.233-.138-.263-.27L6 10.632c-.057-.257-.25-.462-.503-.536L1.279 8.88c-.191-.055-.301-.255-.246-.446.035-.123.134-.218.258-.25l4.182-1.057c.266-.067.47-.28.529-.547l.955-4.435c.042-.195.233-.318.428-.276.135.029.241.132.274.266z",
    transform: "translate(9.544 8.927)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M14.215.977l.154.578c.068.255.27.453.528.515l.535.129c.136.033.22.17.186.305-.021.09-.09.16-.178.185l-.566.156c-.244.067-.435.258-.503.503l-.156.565c-.037.135-.176.214-.311.177-.089-.024-.157-.095-.179-.185l-.129-.534c-.062-.257-.26-.46-.515-.528l-.578-.154c-.135-.036-.215-.174-.179-.31.024-.09.096-.159.187-.18l.548-.128c.267-.062.476-.271.538-.538l.128-.548c.032-.136.168-.22.304-.19.09.022.162.092.186.182z",
    opacity: 0.549,
    transform: "translate(9.544 8.927)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.081,
    d: "M7.66 2.134L8.757 6.6c.064.256.262.458.518.525l4.05 1.059c.193.05.308.247.258.44-.032.122-.125.218-.246.254l-4.086 1.221c-.242.073-.43.267-.492.513l-1.102 4.327c-.049.193-.245.31-.438.26-.132-.034-.233-.138-.263-.27L6 10.632c-.057-.257-.25-.462-.503-.536L1.279 8.88c-.191-.055-.301-.255-.246-.446.035-.123.134-.218.258-.25l4.182-1.057c.266-.067.47-.28.529-.547l.955-4.435c.042-.195.233-.318.428-.276.135.029.241.132.274.266z",
    transform: "translate(9.544 8.927)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M14.215.977l.154.578c.068.255.27.453.528.515l.535.129c.136.033.22.17.186.305-.021.09-.09.16-.178.185l-.566.156c-.244.067-.435.258-.503.503l-.156.565c-.037.135-.176.214-.311.177-.089-.024-.157-.095-.179-.185l-.129-.534c-.062-.257-.26-.46-.515-.528l-.578-.154c-.135-.036-.215-.174-.179-.31.024-.09.096-.159.187-.18l.548-.128c.267-.062.476-.271.538-.538l.128-.548c.032-.136.168-.22.304-.19.09.022.162.092.186.182z",
    opacity: 0.549,
    transform: "translate(9.544 8.927)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupportHelpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "support-help-icon.218161c15ea92f6abb4577183b0b059f.svg";